export default __webpack_public_path__ + "static/media/Recruit's Potency.2002d8c0.jpg";